<template>
  <div class="section-block">
    <div class="block1-list">
      <van-list
        v-model="postState.loading"
        :finished="postState && postState.finished"
        :finished-text="postState.finishText"
        :immediate-check="false"
        @load="handleGetPostList"
      >
        <div v-if="postListArr.length > 0">
          <div
            class="block1-item"
            v-for="(item, index) in postListArr"
            :key="index"
            @click="handleClickItems(item)"
          >
            <img
              src="../../../assets/images/zone/img25.png"
              v-if="item.areaPostbarWorkDataDTOS.length > 0"
              class="icon-tag"
              alt=""
            />
            <img
              src="../../../assets/images/zone/img24.png"
              v-else
              class="icon-tag"
              alt=""
            />
            <div class="item-top">
              <img :src="item && item.headPicUrl" class="top-cover" alt="" />
              <div class="top-con">
                <div class="txt1" v-if="`${item.userIdentity}` === '2'">
                  <!-- {{ item && item.realName }} -->
                   管理员
                </div>
                <div class="txt1 txt2" v-else>{{ item && item.realName }}</div>
                <div class="txt2">
                  <span v-if="`${item.userIdentity}` === '2'"></span>
                  <!-- <span class="txt2-tag" v-if="`${item.userIdentity}` === '2'">{{ userTypeObj[item.userIdentity] }}</span> -->
                  <span class="txt2-tag tag2" v-else-if="`${item.userIdentity}` === '1'">{{ userTypeObj[item.userIdentity] }}</span>
                  <span class="txt2-tag tag-user" v-else>{{ userTypeObj[item.userIdentity] }}</span>
                  <span class="txt2-time">{{ item && item.times }}</span>
                </div>
              </div>
            </div>
            <div class="con-div">
              <div class="item-title">{{ item && item.subjectName }}</div>
              <div class="item-cons" v-html="item.content"></div>
              <div class="item-imgs">
                <div class="imgs-mask" v-if="item && item.isMoreImgs">
                  +{{ item && item.moreNum }}
                </div>
                <img
                  v-for="(item_img, index_img) in item.contentFile"
                  :key="index_img"
                  :src="item_img && item_img.url"
                  class="img-cover"
                  alt=""
                />
              </div>
              <template
                v-if="
                  `${item.isCutTime}` !== '1' &&
                    `${rolesData.studentSign}` === '1'
                "
              >
                <div class="work-div" v-if="item.areaPostbarWorkDTO.length > 0">
                  <img
                    src="../../../assets/images/zone/img26.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">待办任务作业-{{ item && item.tutorName }}导师</div>
                  <div
                    class="work-btn"
                    @click.stop="handleClickItems(item, 'workdetails')"
                  >
                    查看
                  </div>
                </div>
                <div class="work-div worked" v-else>
                  <img
                    src="@/assets/images/zone/img32.png"
                    class="icon-word"
                    alt=""
                  />
                  <div class="work-txt">待办任务作业</div>
                  <div class="work-btn">已过期</div>
                </div>
              </template>
              <div
                class="work-div"
                v-else-if="
                  `${userInfo.memberType}` === '0' &&
                    item.areaPostbarWorkDataDTOS.length <= 0 &&
                    `${rolesData.tutorSign}` === '1'
                "
              >
                <img
                  src="@/assets/images/zone/img26.png"
                  class="icon-word"
                  alt=""
                />
                <div class="work-txt">待办任务作业</div>
                <div
                  class="work-check"
                  v-if="item.areaPostbarWorkDTO.length > 0"
                  @click.stop="handleClickItems(item, 'workdetails')"
                >
                  <img
                    src="@/assets/images/zone/img31.png"
                    class="icon-check"
                    alt=""
                  />
                  <span class="check-txt">已批改</span>
                  <img
                    src="@/assets/images/zone/img23.png"
                    class="icon-more"
                    alt=""
                  />
                </div>
                <div
                  class="work-btn"
                  @click.stop="handleClickItems(item, 'worklist')"
                  v-else
                >
                  批作业
                </div>
              </div>
              <div
                class="work-div"
                v-else-if="
                  `${userInfo.memberType}` === '0' &&
                    item.areaPostbarWorkDataDTOS.length <= 0 &&
                    `${rolesData.peSign}` !== '1'
                "
              >
                <img
                  src="@/assets/images/zone/img26.png"
                  class="icon-word"
                  alt=""
                />
                <div class="work-txt">
                  待办任务作业-{{ item && item.tutorName }}导师
                </div>
                <div
                  class="work-check"
                  v-if="item.areaPostbarWorkDTO.length > 0"
                  @click.stop="handleClickItems(item, 'workdetails')"
                >
                  <img
                    src="@/assets/images/zone/img31.png"
                    class="icon-check"
                    alt=""
                  />
                  <span class="check-txt">已作答</span>
                  <img
                    src="@/assets/images/zone/img23.png"
                    class="icon-more"
                    alt=""
                  />
                </div>
                <div
                  class="work-btn"
                  @click.stop="handleClickItems(item, 'answerwork')"
                  v-else
                >
                  去完成
                </div>
              </div>
              <div
                class="work-div"
                v-else-if="
                  `${userInfo.memberType}` === '1' ||
                    `${rolesData.peSign}` === '1'
                "
              >
                <img
                  src="@/assets/images/zone/img26.png"
                  class="icon-word"
                  alt=""
                />
                <div class="work-txt">待办任务作业</div>
                <div
                  class="work-btn"
                  @click.stop="handleClickItems(item, 'worklist')"
                >
                  查看
                </div>
              </div>
              <div class="work-tip" v-if="item.areaPostbarWorkDataDTOS.length <= 0">
                <div class="left-txt" v-if="item.curTimes">截止时间:{{item.curTimes}}</div>
                <div class="right-txt">{{item.workFinishNum > 0 ? item.workFinishNum : 0}}人已完成</div>
              </div>
              <div
                class="work-div"
                v-if="
                  item.areaPostbarWorkDataDTOS &&
                    item.areaPostbarWorkDataDTOS.length > 0
                "
              >
                <img
                  src="@/assets/images/zone/img22.png"
                  class="icon-word"
                  alt=""
                />
                <div class="work-txt">关联内容</div>
                <div class="work-go">
                  {{ item.areaPostbarWorkDataDTOS[0].title }}
                  <img
                    src="@/assets/images/zone/img23.png"
                    class="icon-more"
                    alt=""
                  />
                </div>
              </div>
              <div class="item-btm">
                <div class="btm-flex">
                  <img
                    src="../../../assets/images/zone/img7.png"
                    class="icon-btm1"
                    alt=""
                  />
                  <span class="btm-num">{{
                    item.visitNum > 0 ? item.visitNum : 0
                  }}</span>
                </div>
                <div class="btm-flex">
                  <img
                    src="@/assets/images/zone/img16.png"
                    class="icon-btm1"
                    alt=""
                  />
                  <span class="btm-num">{{
                    item.commentNum > 0 ? item.commentNum : 0
                  }}</span>
                </div>
                <div class="btm-flex" @click.stop="handleLike(item, index)">
                  <img
                    src="@/assets/images/zone/img20.png"
                    v-if="item.isLike + '' === '1'"
                    class="icon-btm1"
                    alt=""
                  />
                  <img
                    src="@/assets/images/zone/img17.png"
                    v-if="item.isLike + '' === '2'"
                    class="icon-btm1"
                    alt=""
                  />
                  <span class="btm-num">{{
                    item.likeNum > 0 ? item.likeNum : 0
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="empty-block" v-else-if="isNone">
          <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
          <div class="empty-txt">暂无内容</div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
// import { userTypeObj, rolesClick } from '../data'
import { userTypeObj } from '../data'
import { postList, postLike, delLike } from '@/api/zone'
export default {
  props: {
    areaId: '',
    roles: {}
  },
  data() {
    return {
      load: false,
      // 筛选项分页
      postState: {
        pageNo: 1,
        pageSize: 10,
        loading: false,
        finished: false,
        finishText: '没有更多了'
      },
      postListArr: [],
      userTypeObj,
      isNone: false,
      rolesData: {}
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    }
  },
  watch: {
    roles(newval, old) {
      this.rolesData = newval
      this.handleGetPostList()
    }
  },
  mounted() {
    if (this.roles && Object.keys(this.roles).length > 0) {
      this.rolesData = this.roles
      this.handleGetPostList()
    }
  },
  methods: {
    handleGetPostList() {
      let params = {
        pageNum: this.postState.pageNo,
        pageSize: this.postState.pageSize,
        areaId: this.areaId,
        searchContent: this.searchContent,
        type: 4,
        isWork: 1
      }
      if (`${this.rolesData.tutorSign}` === '1') {
        params.tutorId = this.userInfo.id
      }
      postList(params)
        .then(res => {
          this.$toast.clear()
          if (res) {
            if (res.code !== 0 || !res.data || !res.data.list) {
              this.postState.loading = false
              this.postState.finished = true
              return false
            }
            this.postState.loading = false
            res.data.list = res.data.list.map(item => {
              item.times = this.$moment(item.auditTime * 1).format(
                'MM-DD HH:mm'
              )
              item.curTimes = item.cutTime ? this.$moment(item.cutTime * 1).format('YYYY/MM/DD HH:mm') : ''
              if (item.contentFile.length > 3) {
                item.isMoreImgs = true
                item.moreNum = item.contentFile.length - 3
              }
              item.contentFile = item.contentFile.splice(0, 3)
              return item
            })
            if (res.data.list.length < this.postState.pageSize) {
              this.postState.finished = true
            }
            if (res.code === 0 && res.data.list) {
              this.postListArr = this.postListArr.concat(res.data.list)
            }
            this.postState.pageNo++
            if (this.postListArr.length === 0) {
              this.isNone = true
              this.postState.finishText = ''
            }
          }
        })
        .catch(err => {
          this.$toast.clear()
          console.log('err:', err)
        })
    },
    handleLike(item, index) {
      // if (rolesClick(this.rolesData, this.userInfo)) return
      if (`${item.isLike}` === '1') {
        delLike({ id: item.likeBaseId }).then(() => {
          this.postListArr[index].likeNum--
          this.$toast('取消点赞成功')
          this.postListArr[index].isLike = '2'
        })
        return
      }
      let params = {
        likeId: item.id,
        likeTitle: item.subjectName,
        userId: this.userInfo.id,
        targetUserId: item.userId,
        targetUserName: item.realName,
        targetHeadPic: item.headPicUrl,
        kind: '1'
      }
      if (item.contentFile && item.contentFile.length > 0) {
        params.cover = item.contentFile[0].url
      }
      if (item.liveDTO && item.liveDTO.length > 0) {
        params.cover = item.liveDTO.liveCover
      }
      if (item.coverInfo && item.coverInfo.url) {
        params.cover = item.coverInfo.url
      }
      postLike(params).then(res => {
        console.log(res)
        this.postListArr[index].likeNum++
        this.postListArr[index].likeBaseId = res.data
        this.postListArr[index].isLike = '1'
        this.$toast('点赞成功')
      })
    },
    handleClickItems(item, type) {
      let path, query
      path = '/dccDetail'
      query = {
        postId: item.id,
        areaId: this.areaId,
        entrance: 53,
        channel: 53,
        businessId: this.areaId,
      }
      if (type === 'answerwork') {
        path = '/answerWork'
        query = {
          postId: item.id,
          areaId: this.areaId
        }
      }
      if (type === 'workdetails') {
        path = '/workDetails'
        query = {
          workId: item.areaPostbarWorkDTO[0].id,
          workType: 'answer',
          areaId: this.areaId
        }
      }
      if (type === 'worklist') {
        path = '/workList'
        query = {
          postId: item.id,
          areaId: this.areaId,
        }
      }
      this.$router.push({
        path,
        query
      })
    }
  }
}
</script>
<style lang="less" scoped>
.section-block {
  background: linear-gradient(180deg, #f6f8fa 6%, #edf1f4 8%, #f2f7fa 100%);
  padding: 16px;
  padding-top: 0;
  box-sizing: border-box;
  min-height: calc(100vh - 260px);
}

.block1-list {
  .block1-item {
    background-color: #fff;
    margin-bottom: 10px;
    border-radius: 12px;
    border: 1px solid #fff;
    box-sizing: border-box;
    position: relative;

    .icon-tag {
      width: 27px;
      position: absolute;
      right: 0;
      top: 0;
    }

    .item-top {
      display: flex;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      background: linear-gradient(90.00deg, rgb(241, 239, 237),rgb(255, 255, 255) 100%);
      border-radius: 12px 12px 0 0;

      .top-cover {
        width: 32px;
        height: 32px;
        border-radius: 50%;
        margin-right: 4px;
      }

      .top-con {
        display: flex;
        flex-direction: column;

        .txt1 {
          line-height: 20px;
          font-size: 14px;
          color: #EB1700;

          &.txt2 {
            color: #000000;
          }
        }

        .txt2 {
          display: flex;
          align-items: center;

          .txt2-tag {
            width: 40px;
            height: 14px;
            border-radius: 2px;
            border: 1px solid #EB1700;
            margin-right: 4px;
            color: #EB1700;
            font-size: 10px;
            text-align: center;

            &.tag2 {
              width: 32px;
              border-color: #0F68B2;
              color: #0F68B2;
            }

            &.tag-user {
              width: 32px;
              color: #FF6017;
              border-color: #FF6017;
            }
          }

          .txt2-time {
            font-size: 12px;
            font-weight: 500;
            color: #7a8494;
          }
        }
      }
    }

    .con-div {
      padding: 10px;
      padding-bottom: 0;
      box-sizing: border-box;

      .item-title {
        font-size: 14px;
        color: #202020;
        font-weight: 600;
        line-height: 20px;
        margin-bottom: 5px;
      }

      .item-cons {
        font-size: 12px;
        color: #7a8494;
        line-height: 20px;
        margin-bottom: 4px;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
      }

      .item-imgs {
        display: flex;
        position: relative;
        flex-wrap: wrap;

        .img-cover {
          width: 100px;
          margin-right: 10px;
          height: 100px;
          display: block;
          border-radius: 4px;
          object-fit: cover;

          &:nth-last-child(1) {
            margin-right: 0;
          }
        }

        .imgs-mask {
          position: absolute;
          right: 0;
          top: 0;
          width: 100px;
          height: 100px;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          color: #fff;
        }

        .video-cover {
          width: 100%;
          height: 152px;
          object-fit: cover;
        }

        .icon-video {
          position: absolute;
          width: 40px;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .item-comment {
        background-color: #f6f6f6;
        padding: 10px 8px;
        box-sizing: border-box;
        margin-top: 10px;
        border-radius: 4px;

        .comment-block {
          display: flex;
          align-items: center;
          margin-bottom: 10px;

          &:nth-last-child(1) {
            margin-bottom: 0;
          }

          .head-cover {
            width: 18px;
            height: 18px;
            border-radius: 50%;
            margin-right: 4px;
            display: block;
          }

          .comment-txt {
            font-size: 12px;
            color: #343434;
          }
        }
      }
    }

    .work-div {
      display: flex;
      align-items: center;
      padding-right: 10px;
      box-sizing: border-box;
      background: rgb(246, 246, 246);
      border-radius: 4px;
      height: 32px;
      margin-top: 10px;

      &.worked {
        background: #f6f6f6;

        .work-btn {
          background: #dfdddd;
          color: #7a8494;
          box-shadow: none;
        }
      }

      .icon-word {
        width: 18px;
        display: block;
        margin: 0 5px;
      }

      .work-txt {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 14px;
        color: #202020;
        white-space: nowrap;
      }

      .work-go {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #EB1700;

        .icon-more {
          width: 13px;
          display: block;
          margin-left: 4px;
          transform: translateY(2px);
        }
      }

      .work-btn {
        background: #EB1700;
        box-shadow: 0px 2px 4px 0px rgba(255, 91, 12, 0.25);
        border-radius: 4px;
        width: 44px;
        height: 18px;
        line-height: 18px;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }

      .work-check {
        display: flex;
        align-items: center;
        height: 22px;

        .icon-check {
          display: block;
          width: 15px;
        }

        .check-txt {
          padding: 0 2px;
          box-sizing: border-box;
          font-size: 14px;
          color: #EB1700;
        }

        .icon-more {
          display: block;
          width: 5px;
        }
      }
    }

    .work-tip {
      margin-top: 10px;
      height: 20px;
      display: flex;
      justify-content: space-between;

      .left-txt {
        font-size: 13px;
        color: #7a8494;
      }

      .right-txt {
        font-size: 14px;
        color: #7a8494;
      }
    }

    .item-btm {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 40px;

      .btm-flex {
        display: flex;
        align-items: center;
        height: 40px;

        .icon-btm1 {
          width: 16px;
          margin-right: 4px;
          display: block;
        }

        .btm-num {
          line-height: 40px;
          font-size: 12px;
          color: #7a8494;
          display: block;
        }
      }
    }
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 60px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/RTCZone/compontents/work.vue